import { render, staticRenderFns } from "./EditarDetallesPartido.vue?vue&type=template&id=087f418a&scoped=true"
import script from "./EditarDetallesPartido.vue?vue&type=script&lang=ts"
export * from "./EditarDetallesPartido.vue?vue&type=script&lang=ts"
import style0 from "./EditarDetallesPartido.vue?vue&type=style&index=0&id=087f418a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f418a",
  null
  
)

export default component.exports